/* eslint-disable */
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols
// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.
import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AuthLoginRouteImport } from './routes/_auth.login';
import { Route as appRatesRouteImport } from './routes/(app)/rates';
import { Route as appDashboardRouteImport } from './routes/(app)/dashboard';
import { Route as appLayoutRouteImport } from './routes/(app)/_layout';
const IndexRoute = IndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => rootRouteImport,
});
const AuthLoginRoute = AuthLoginRouteImport.update({
    id: '/_auth/login',
    path: '/login',
    getParentRoute: () => rootRouteImport,
});
const appRatesRoute = appRatesRouteImport.update({
    id: '/(app)/rates',
    path: '/rates',
    getParentRoute: () => rootRouteImport,
});
const appDashboardRoute = appDashboardRouteImport.update({
    id: '/(app)/dashboard',
    path: '/dashboard',
    getParentRoute: () => rootRouteImport,
});
const appLayoutRoute = appLayoutRouteImport.update({
    id: '/(app)/_layout',
    getParentRoute: () => rootRouteImport,
});
const rootRouteChildren = {
    IndexRoute: IndexRoute,
    appLayoutRoute: appLayoutRoute,
    appDashboardRoute: appDashboardRoute,
    appRatesRoute: appRatesRoute,
    AuthLoginRoute: AuthLoginRoute,
};
export const routeTree = rootRouteImport
    ._addFileChildren(rootRouteChildren)
    ._addFileTypes();
